import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      marginBottom: theme.spacing(2),
    },
    tableRow: {
      cursor: 'pointer',
    },
    textSecondary: {
      color: theme.palette.text.secondary,
    },
  })
);
